import React from "react"
import {
  NavItem,
  Radio,
} from "react-bootstrap"

import { ls } from "../../../locale"


const ApplePayPNG  = new URL('../../../images/apple-pay.png',       import.meta.url).href
const OmanDebit    = new URL('../../../images/oman-deb.png',        import.meta.url).href
const MastercardPNG = new URL('../../../images/mastercard-logo.png', import.meta.url).href
const VisaLogoPNG  = new URL('../../../images/visa-logo.png',       import.meta.url).href
const MadaLogoPNG  = new URL('../../../images/mada-logo.png',       import.meta.url).href
const KnetLogoPNG  = new URL('../../../images/knet-logo.png',       import.meta.url).href
const VoucherPNR   = new URL('../../../images/voucher.png',         import.meta.url).href


export function TabNavItemWallet({paymentMethodCode, setPaymentMethodState}) {

  const rPayment = ls.t('Payment');

  return (
    <PaymentNavItem paymentCode="SPW"
      paymentName={rPayment.ApplePay.Label}
      selected={paymentMethodCode === "SPW"}
      setPaymentMethodState={setPaymentMethodState}
      logos={[ApplePayPNG]}
      >
    </PaymentNavItem>
  )
}

export function TabNavItemON({paymentMethodCode, setPaymentMethodState}) {

  const rPayment = ls.t('Payment');

  return (
    <PaymentNavItem paymentCode="ON"
      paymentName={rPayment.OmanNet.Label}
      selected={paymentMethodCode === "ON"}
      setPaymentMethodState={setPaymentMethodState}
      logos={[OmanDebit]}>
  </PaymentNavItem>
  )
}

export function TabNavItemKNET({paymentMethodCode, setPaymentMethodState}) {

  const rPayment = ls.t('Payment');

  return (
    <PaymentNavItem paymentCode="KNET"
    paymentName={rPayment.Knet.Label}
    selected={paymentMethodCode === "KNET"}
    setPaymentMethodState={setPaymentMethodState}
    logos={[KnetLogoPNG]}>
  </PaymentNavItem>
  )
}

export function TabNavItemSP({paymentMethodCode, setPaymentMethodState}) {

  const rPayment = ls.t('Payment');

  return (
    <PaymentNavItem paymentCode="SP"
      paymentName={rPayment.SmartPay.Label}
      selected={paymentMethodCode === "SP"}
      setPaymentMethodState={setPaymentMethodState}
      logos={[OmanDebit]}>
  </PaymentNavItem>
  )
}

export function TabNavItemCS({paymentMethodCode, setPaymentMethodState }) {

  const rPayment = ls.t('Payment');
  const label = rPayment.CreditCard.Label

  return (
    <PaymentNavItem paymentCode="CS"
      paymentName={label}
      selected={paymentMethodCode === "CS"}
      setPaymentMethodState={setPaymentMethodState}
      logos={[VisaLogoPNG, MastercardPNG]}>
    </PaymentNavItem>
  )
}

export function TabNavItemMada({paymentMethodCode, setPaymentMethodState }) {

  const rPayment = ls.t('Payment');
  const label = rPayment.CreditCard.LabelMada

  return (
    <PaymentNavItem paymentCode="MADA"
      paymentName={label}
      selected={paymentMethodCode === "MADA"}
      setPaymentMethodState={setPaymentMethodState}
      logos={[MadaLogoPNG]}>
    </PaymentNavItem>
  )
}

export function TabNavItemVCHR({paymentMethodCode, setPaymentMethodState}) {

  const rPayment = ls.t('Payment');

  return (
    <PaymentNavItem paymentCode="VCHR"
      paymentName={rPayment.Voucher.Label}
      selected={paymentMethodCode === "VCHR"}
      setPaymentMethodState={setPaymentMethodState}
      logos={[VoucherPNR]}>
    </PaymentNavItem>
  )
}

export function TabNavItemINVC({paymentMethodCode, setPaymentMethodState}) {

  const rPayment = ls.t('Payment');

  return (
    <PaymentNavItem paymentCode="INVC"
      paymentName={rPayment.AGPay.Label}
      selected={paymentMethodCode === "INVC"}
      setPaymentMethodState={setPaymentMethodState} />
  )
}

export function TabNavItemPL ({paymentMethodCode, setPaymentMethodState}) {
  const rPayment = ls.t('Payment');

  return (
    <PaymentNavItem paymentCode="PL"
      paymentName={rPayment.PayLater.Label}
      selected={paymentMethodCode === "PL"}
      setPaymentMethodState={setPaymentMethodState} />
  )
}

export function TabNavItemFT({paymentMethodCode, setPaymentMethodState}) {
  const rPayment = ls.t('Payment');

  return (
    <PaymentNavItem paymentCode="FT"
      paymentName={rPayment.FreeTicket.Label}
      selected={paymentMethodCode === "FT"}
      setPaymentMethodState={setPaymentMethodState} />
  )
}

export function TabNavItemCASH({paymentMethodCode, setPaymentMethodState}) {
  return (
    <PaymentNavItem paymentCode="CASH"
      paymentName={'Cash'}
      selected={paymentMethodCode === 'CASH'}
      setPaymentMethodState={setPaymentMethodState} />
  )
}

function PaymentNavItem(props) {

  const {paymentName, paymentCode, selected,  setPaymentMethodState, logos} = props;

  return (      
  <NavItem eventKey={paymentCode} onClick={() => setPaymentMethodState(paymentCode)} className={ selected ? "active tw-bg-white" : "tw-bg-gray-50"}>
    <Radio name="paymentMethodCode" value={paymentCode} checked={selected} onChange={() => {}}>
      <label></label>
      <p className="tw-flex tw-items-center tw-justify-between tw-gap-1">
        <span className="tw-flex-1 tw-text-lg">{paymentName}</span>
        {Array.isArray(logos) && logos.map((logo, index) => (
          <img key={index} src={logo} alt={paymentName} height={18} />
        ))}
      </p>
    </Radio>
  </NavItem>)
}